document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.section-modal');

  modals.forEach((modal) => {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  });

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-modal-open]');
    if (!openTrigger) return;

    const modalId = openTrigger.getAttribute('data-modal-open');
    if (!modalId) return;

    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
  });

  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-modal-close]');
    if (!closeTrigger) return;

    const modal = closeTrigger.closest('.section-modal');
    if (!modal) return;

    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const activeModal = document.querySelector('.modal.is-active');
    if (!activeModal) return;

    activeModal.classList.remove('is-active');
    activeModal.setAttribute('aria-hidden', 'true');
  });
});